import { DocumentModel } from '../../../../shared/models/simple-types/document.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcComponentsService } from '../../bc-components.service';
import { saveAs } from 'file-saver';

export interface DialogData {
  idBc: number;
  documents: DocumentModel[];
}

@Component({
  selector: 'app-modal-show-bc-document',
  templateUrl: './modal-show-bc-document.component.html',
  styleUrls: ['./modal-show-bc-document.component.scss']
})

export class ModalShowBcDocumentComponent implements OnInit {

  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private bcService: BcComponentsService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }

  visualiseDoc(doc: DocumentModel, idBc: number): void {
    this.bcService.getDocumentById(idBc, doc.id).subscribe((res: Blob) => {
      if(res.type !== 'application/pdf') {
        saveAs(res, doc.id);
      } else {
        const url = URL.createObjectURL(res);
        window.open(url, '_blank');
      }
    });
  }

  onOpenDoc(doc: DocumentModel, idBc: number): void {
    this.bcService.getDocumentById(idBc, doc.id).subscribe((res: Blob) => {
      saveAs(res, doc.code);
    });
  }

  onDeleteDoc(doc: DocumentModel, idBc: number): void {
    this.bcService.deleteDocument(idBc, doc.id).subscribe(avancement => {
      if(avancement === 100){
        this.data.documents = this.data.documents.filter(document => document.id !== doc.id);
        this.toastr.success('Le fichier : ' + doc.libelle + ' à bien été supprimé.');
      }
    });
  }
}
